import { DEFAULT_LAYER_INFO as m } from "./index.es295.js";
import { ENABLE_POPSTATS_2023_LAYER_INFO as e } from "./index.es296.js";
import { EXTENDED_MOSAIC_OPTIONS_2024_LAYER_INFO as A } from "./index.es297.js";
import { MIGRATION_TRENDS_LAYER_INFO as T, MIGRATION_TRENDS_LAYER_INFO_202504 as n } from "./index.es298.js";
import { ENABLE_POPSTATS_2024_LAYER_INFO as s } from "./index.es299.js";
const t = {
  ...m,
  ...A,
  ...T
}, R = (r, o) => o && r in n ? n[r] : r in s ? s[r] : r in e ? e[r] : t[r], i = (r, o) => Object.entries(o).map(([_, E]) => E.layerCategory === r ? _ : null).filter(Boolean), L = i(
  "Psychographics",
  t
), f = i(
  "Demographics",
  t
), l = i(
  "Crime Risks",
  t
), p = i(
  "Migration Trends",
  t
);
export {
  l as FullCrimeRisksKeys,
  f as FullDemographicsKeys,
  L as FullPsychographicsKeys,
  p as MigrationTrendsKeys,
  t as THEMATIC_LAYER_MAPPING,
  R as getThematicLayerInfo
};
//# sourceMappingURL=index.es90.js.map
